/**
 * Social sharing buttons script
 */
class Epsilon_Calculator {
    constructor() {
        if(!$('.epsilon-calculator').length) {
            return;
        }

        this.initCalculator();
    }
    initCalculator() {
        $('.epsilon-calculator input').on('input', () => {
            $('.epsilon-calculator-results').addClass('is-hidden');
        });

        $('.epsilon-calculator-estimate .btn').on('click', e => {
            e.preventDefault();
            this.calculate();
            $('.epsilon-calculator-results').removeClass('is-hidden');
        });

        $('.epsilon-calculator input[name="company_type"]').on('input', e => {
            let companyType = $('.epsilon-calculator input[name="company_type"]:checked').val();

            if (companyType === 'kpir') {
                $('.epsilon-calculator-item-bank-account input[name="account_items"]').val('0');
                $('.epsilon-calculator-item-bank-account').addClass('is-hidden');
            } else {
                $('.epsilon-calculator-item-bank-account').removeClass('is-hidden');
            }
        });

        let companyType = $('.epsilon-calculator input[name="company_type"]:checked').val();

        if (companyType === 'kpir') {
            $('.epsilon-calculator-item-bank-account input[name="account_items"]').val('0');
            $('.epsilon-calculator-item-bank-account').addClass('is-hidden');
        } else {
            $('.epsilon-calculator-item-bank-account').removeClass('is-hidden');
        }
    }

    calculate () {
        let companyType = $('.epsilon-calculator input[name="company_type"]:checked').val();
        let vat = $('.epsilon-calculator input[name="vat"]:checked').val();
        let invoiceSell = $('.epsilon-calculator input[name="invoice_sell"]').val();
        let invoiceBuy = $('.epsilon-calculator input[name="invoice_buy"]').val();
        let accountItems = $('.epsilon-calculator input[name="account_items"]').val();
        let otherDocs = $('.epsilon-calculator input[name="other_docs"]').val();
        let employees = $('.epsilon-calculator input[name="employees"]').val();
        let accountItemsDocs = Math.ceil(accountItems / 10);

        if (companyType === 'kpir') {
            accountItemsDocs = 0;
        }

        let documentsCount = parseInt(invoiceSell, 10) + parseInt(invoiceBuy, 10) + accountItemsDocs + parseInt(otherDocs, 10);
        let total = 30; // owner fee
        let documentsPrice = 0;

        if (companyType === 'kpir') {
            documentsPrice = vat === 'yes' ? 350 : 300;

            if (documentsCount > 30 && documentsCount <= 60) {
                documentsPrice = vat === 'yes' ? 700 : 600;
            } else if (documentsCount > 60) {
                documentsPrice = 1000;
            }
        } else if (companyType === 'ryczalt') {
            documentsPrice = vat === 'yes' ? 300 : 250;

            if (documentsCount > 30 && documentsCount <= 60) {
                documentsPrice = vat === 'yes' ? 600 : 500;
            } else if (documentsCount > 60) {
                documentsPrice = vat === 'yes' ? 1000 : 800;
            }
        } else if (companyType === 'ksiegi') {
            documentsPrice = vat === 'yes' ? 800 : 700;

            if (documentsCount > 30 && documentsCount <= 60) {
                documentsPrice = vat === 'yes' ? 1600 : 1400;
            } else if (documentsCount > 60) {
                documentsPrice = vat === 'yes' ? 2500 : 2200;
            }
        }

        total = total + documentsPrice + (employees * 50);

        if (document.documentElement.getAttribute('lang') === 'pl-PL') {
            $('.epsilon-calculator .epsilon-calculator-docs-total').text(documentsCount + ' szt.');
            
            if (documentsCount > 200) {
                $('.epsilon-calculator .epsilon-calculator-total').text('WYCENA INDYWIDUALNA');
                $('.epsilon-calculator .epsilon-calculator-over-200-docs').removeClass('is-hidden');
            } else {
                $('.epsilon-calculator .epsilon-calculator-total').text(Number(total).toFixed(2) + ' zł');
                $('.epsilon-calculator .epsilon-calculator-over-200-docs').addClass('is-hidden');
            }
        } else {
            $('.epsilon-calculator .epsilon-calculator-docs-total').text(documentsCount + ' pcs.');
            
            if (documentsCount > 200) {
                $('.epsilon-calculator .epsilon-calculator-total').text('INDIVIDUAL PRICING');
                $('.epsilon-calculator .epsilon-calculator-over-200-docs').removeClass('is-hidden');
            } else {
                $('.epsilon-calculator .epsilon-calculator-total').text(Number(total).toFixed(2) + ' PLN');
                $('.epsilon-calculator .epsilon-calculator-over-200-docs').addClass('is-hidden');
            }
        }
    }
}